import TrucksModule from 'modules/Admin/trucks/Trucks'

function TrucksPage() {
  return (
    <div data-testid="adminTrucksPage">
      <TrucksModule />
    </div>
  )
}

export default TrucksPage
